/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

const View = () => (
  <Message
    icon="question"
    header="Sondage"
    content={`Le sondage est géré via le module dédié.`}
  />
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/surveys-list/View.js